import React from 'react';
import { NavLink } from 'react-router-dom';
import { Logo, Icon, ICONS } from '@/components/brand';

// The stylesheet already styles `.sh-nav a` alongside `.sh-nav button` and keys
// the underline off `.is-active`, so the links need no new CSS — they just have
// to emit that class name rather than react-router's default `active`.
const navClass = ({ isActive }: { isActive: boolean }) => (isActive ? 'is-active' : '');

interface TopBarProps {
  isConnected: boolean;
  short?: boolean;
  address?: string;
  formatAddress: (a: string) => string;
  chainName: string;
  isCorrectNetwork: boolean;
  isOwner: boolean;
  /** The monthly payout contract is a separate deployment and may not exist on
   *  this chain, so the tab is not simply tied to `isOwner`. */
  showPayouts?: boolean;
  /** False for an owner with no allocation of their own: "/" would bounce them
   *  straight back to /admin, so the tab could never even light up. */
  showAllocation?: boolean;
  onOpenWallet?: () => void;
}

export const TopBar: React.FC<TopBarProps> = ({
  isConnected,
  short,
  address,
  formatAddress,
  chainName,
  isCorrectNetwork,
  isOwner,
  showPayouts = false,
  showAllocation = true,
  onOpenWallet,
}) => {
  const showNav = !short && isConnected;
  return (
    <header className="sh-topbar">
      <Logo />
      {showNav && (
        <nav className="sh-nav">
          {showAllocation && (
            <NavLink to="/" end className={navClass}>
              Allocation
            </NavLink>
          )}
          {isOwner && (
            // No `end`: the tab stays lit on /admin/lock/:address too.
            <NavLink to="/admin" className={navClass}>
              Admin
            </NavLink>
          )}
          {showPayouts && (
            // No `end`, for the same reason: /payroll/entry/:id keeps it lit.
            <NavLink to="/payroll" className={navClass}>
              Payouts
            </NavLink>
          )}
        </nav>
      )}
      <div className="sh-topbar-right">
        <span className="sh-net" title={chainName}>
          <span className={`sh-dot ${isCorrectNetwork ? '' : 'sh-dot-danger'}`} />
          {chainName}
        </span>
        {isConnected && address ? (
          <button type="button" className="sh-wallet-pill" onClick={onOpenWallet}>
            <span className="sh-avatar" aria-hidden="true" />
            <span className="sh-mono">{formatAddress(address)}</span>
            <Icon d={ICONS.caret} size={12} />
          </button>
        ) : null}
      </div>
    </header>
  );
};
